import React from 'react';
import FontsDefault from '../../Assistant/DefaultStyle';

import {
  AiOutlineHome,
  AiOutlineWhatsApp,
  AiOutlineMail,
  AiFillClockCircle,
} from 'react-icons/ai';

function ContactFooter() {
  return (
    <div className='lg:w-3/12 w-full p-4'>
      <h1 className={`${FontsDefault.text4xl} font-bold text-amber`}>
        تواصل معنا
      </h1>

      <div className='mt-6 flex '>
        <div>
          <AiOutlineWhatsApp
            className={`${FontsDefault.text4xl} ml-4 text-amber`}
          />
        </div>
        <div>
          <p className="text-gray700">566012888(970+)</p>
        </div>
      </div>

      <div className='mt-6 flex'>
        <div>
          <AiOutlineMail
            className={`${FontsDefault.text4xl} ml-4 text-amber`}
          />
        </div>

        <div>
          <p className="text-gray700">fullmark095@gmail.com</p>
        </div>
      </div>

      <div className='mt-6 flex'>
        <div>
          <AiFillClockCircle
            className={`${FontsDefault.text4xl} ml-4  text-amber`}
          />
        </div>
        <div>
          <p className="text-gray700">8:30 - 4:00</p>
        </div>
      </div>
    </div>
  );
}

export default ContactFooter;
